import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getColoursList = createAsyncThunk("/colourlist", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}colour/api/v1/list`, data, {
         headers: {
            "Content-Type": "application/json",
          },
      // headers: {
      //   "auth-token": token,
      //   "Content-Type": "application/json",
      // },
    });
    console.log("re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching Colours", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch Colours");
  }
});